import React, { useEffect, useState } from 'react';
import styles from '../../styles';
import { css } from '@emotion/core';

export const FooterPager = () => {
  const [prevNext, setPrevNext] = useState({ prev: null, next: null });

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const sidebar = document.getElementById('doc-sidebar');
    if (!sidebar) return;

    const anchors = Array.from(sidebar.querySelectorAll('a[href^="/"]'));

    const norm = (p = '') => p.replace(/\/+$/, '');

    const entries = [];
    const seen = new Set();

    anchors.forEach((a) => {
      try {
        const url = new URL(a.getAttribute('href'), window.location.origin);
        const pathname = norm(url.pathname);

        if (!seen.has(pathname)) {
          seen.add(pathname);
          entries.push({
            pathname,
            href: pathname,
            label: a.textContent?.trim() || pathname.split('/').pop() || 'Untitled',
          });
        }
      } catch {}
    });

    if (!entries.length) return;

    const currentPath = norm(window.location.pathname);
    const idx = entries.findIndex((e) => e.pathname === currentPath);

    const prev = idx > 0 ? entries[idx - 1] : null;
    const next = idx >= 0 && idx < entries.length - 1 ? entries[idx + 1] : null;

    setPrevNext({ prev, next });
  }, []);

  if (!prevNext.prev && !prevNext.next) return null;
  if (typeof window === 'undefined') return null;

  return (
    <nav css={pagerStyle.root}>
      {prevNext.prev ? (
        <a css={[pagerStyle.link, pagerStyle.prev]} href={prevNext.prev.href}>
          <span css={pagerStyle.kicker}>Previous</span>
          <span css={pagerStyle.title}>{prevNext.prev.label}</span>
          {/* svg arrow */}
          <svg
            css={css`
              position: absolute;
              top: 50%;
              left: 1rem;
              width: 1.5rem;
              height: 1.5rem;
              transform: translateY(-50%);
              stroke: ${styles.color.grey};
            `}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={2}
            strokeLinecap='round'
            strokeLinejoin='round'>
            <path d='M15 18l-6-6 6-6' />
          </svg>
        </a>
      ) : (
        <span />
      )}

      {prevNext.next ? (
        <a css={[pagerStyle.link, pagerStyle.next]} href={prevNext.next.href}>
          <span css={pagerStyle.kicker}>Next</span>
          <span css={pagerStyle.title}>{prevNext.next.label}</span>
          <svg
            css={css`
              position: absolute;
              top: 50%;
              right: 1rem;
              width: 1.5rem;
              height: 1.5rem;
              transform: translateY(-50%);
              stroke: ${styles.color.grey};
            `}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={2}
            strokeLinecap='round'
            strokeLinejoin='round'>
            <path d='M9 18l6-6-6-6' />
          </svg>
        </a>
      ) : (
        <span />
      )}
    </nav>
  );
};

const pagerStyle = {
  root: css`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${styles.spacing.sm};
    margin: ${styles.spacing.lg} 0 ${styles.spacing.xl};
    padding-top: ${styles.spacing.md};
    border-top: 1px solid ${styles.border.color.grey};
  `,
  link: css`
    display: flex;
    position: relative;
    flex-direction: column;
    gap: ${styles.spacing.nano};
    text-decoration: none;
    border: 1px solid ${styles.border.color.grey};
    border-radius: 8px;
    background: ${styles.color.white};
    transition: background 0.15s ease, border-color 0.15s ease, transform 0.06s ease;
    &:hover {
      background: ${styles.color.xxLightPurple || '#fafafa'};
      transform: translateY(-1px);
    }
  `,
  prev: css`
    justify-self: start;
    padding: 1rem 3.5rem 1rem 4.5rem;
  `,
  next: css`
    justify-self: end;
    text-align: right;
    padding: 1rem 4.5rem 1rem 3.5rem;
  `,
  kicker: css`
    font-size: 11px;
    color: ${styles.color.xLightGrey || '#999'};
    text-transform: uppercase;
    letter-spacing: 0.04em;
  `,
  title: css`
    color: ${styles.color.black};
    font-weight: ${styles.font.weight.medium};
  `,
};
